import type { IEnhancePromptProps } from 'entities/AIAgent/actions/enhancePrompt/EnhancePrompt'
import { ChatbotApi, ChatbotInstructionType } from 'entities/Chatbot'
import { sendEnhancePromptLogEvent } from 'entities/AIAgent/actions/enhancePrompt/sendEnhancePromptLogEvent'
import { type IEntitiesStore } from 'entities/EntitiesExport'

const agentTypeMap: Record<ChatbotInstructionType, string> = {
  [ChatbotInstructionType.LeadQualification]: 'AI Data Collection',
  [ChatbotInstructionType.Custom]: 'Custom',
  [ChatbotInstructionType.FAQ]: 'FAQ',
  [ChatbotInstructionType.BookAppointment]: 'Booking Agent',
  [ChatbotInstructionType.Support]: 'Support',
  [ChatbotInstructionType.Unified]: 'Unified Agent',
}

export const requestTextingAgentEnhance =
  (
    entities: IEntitiesStore,
    promptData: {
      chatbotType: ChatbotInstructionType
      usesKnowledgeBase: boolean
      chatbotId: number
    }
  ): IEnhancePromptProps['requestEnhance'] =>
  async (prompt, signal) => {
    sendEnhancePromptLogEvent(entities, {
      agentType: agentTypeMap[promptData.chatbotType],
      agent_id: promptData.chatbotId,
    })
    const { data } = await ChatbotApi.enhancePrompt(
      { ...promptData, prompt },
      {
        signal,
      }
    )
    return data.improvedPrompt
  }
